export const updateNotifs = 'update-main-header-notifs';
export const notifsEndpointCalled = 'main-header-notifications-endpoint:done';
export const open = 'main-header-search:open';
export const closed = 'main-header-search:closed';
export const clickOnPremobileButton = 'main-header-nav:premobile-open';
